import mediaViewItems from 'modules/Media/computed/mediaViewItems'

const handleShiftKey = ({ props, state, resolve }) => {
  const mediaView = resolve.value(mediaViewItems)
  const clickedMedia = state.get(props.path)
  const currentMedia = state.get(state.get('media.currentFile'))
  let firstInOperation = false
  let lastInOperation = false
  const medias = []

  const hasHit = id => {
    return id === clickedMedia.id || id === currentMedia.id
  }

  Object.keys(mediaView).forEach(view => {
    const section = mediaView[view]
    section.files.forEach(file => {
      if (!firstInOperation) {
        if (hasHit(file.id)) {
          medias.push(file.id)
          firstInOperation = true
        }
      } else {
        if (!lastInOperation) {
          medias.push(file.id)
          if (hasHit(file.id)) {
            lastInOperation = true
          }
        }
      }
    })
  })
  medias.forEach(id => {
    state.set(`media.files.${id}.selected`, true)
  })
}

export default handleShiftKey



// WEBPACK FOOTER //
// ./src/modules/Media/actions/handleShiftKey.js